<ng-container [ngSwitch]="getScreenTemplate()">
  <basic-icon-bar></basic-icon-bar>
  <basic-menu-indicator></basic-menu-indicator>
  <div class="brightness-control" [ngStyle]="{'opacity':brightness}"></div>
  <div class="screenPanel">
      <div #content></div>
  </div>

 <!--
  <div class="net-screen screen-element" [ngClass]="{'debug':debug}">
	<screen-dashboard class="screen-element" [debug]="debug" *ngSwitchCase="'dashboard'"></screen-dashboard>
	<screen-idle class="screen-element" [debug]="debug" *ngSwitchCase="'idle'"></screen-idle>
	<screen-quickveto class="screen-element" [debug]="debug" *ngSwitchCase="'quickveto'"></screen-quickveto>
  	<screen-quickaction class="screen-element" [debug]="debug" *ngSwitchCase="'quickaction'"></screen-quickaction>
  	<screen-waterpressure class="screen-element" [debug]="debug" *ngSwitchCase="'waterpressure'"></screen-waterpressure>
  	<screen-settingsvalue class="screen-element" [debug]="debug" *ngSwitchCase="'settingsvalue'"></screen-settingsvalue>
  	<screen-toast class="screen-element" [debug]="debug" *ngSwitchCase="'toast'"></screen-toast>
  	<screen-help class="screen-element" [debug]="debug" *ngSwitchCase="'help'"></screen-help>
  	<screen-menu class="screen-element" [debug]="debug" *ngSwitchCase="'menu'"></screen-menu>
    <screen-timeset class="screen-element" [debug]="debug" *ngSwitchCase="'timeset'"></screen-timeset>

    <screen-loadinganimation class="screen-element" [debug]="debug" *ngSwitchCase="'loadinganimation'"></screen-loadinganimation>
	</div>
  	-->
</ng-container>
